import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-view-list-container, [app-view-list-container]',
  templateUrl: './view-list-container.component.html',
  styleUrls: ['./view-list-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewListContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
